const getCsvFormattedNumber = (amount: string | number) => {
  const transformedAmount = parseFloat(`${amount}`);
  const decimalFixedAmount =
    parseFloat(`${transformedAmount}`) === parseFloat(transformedAmount.toFixed(2))
      ? transformedAmount
      : transformedAmount.toFixed(2);

  const formattedAmount =
    decimalFixedAmount.toString() ===
    parseInt(decimalFixedAmount.toLocaleString()).toString()
      ? parseInt(decimalFixedAmount.toLocaleString())
      : decimalFixedAmount.toLocaleString();

  return formattedAmount;
};

const getAbbreviatedNumber = (num: number): string => {
  if (num >= 1_000_000_000) {
    return `${(num / 1_000_000_000).toFixed(2)} b`;
  } else if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(2)} m`;
  } else if (num >= 1_000) {
    return `${(num / 1_000).toFixed(2)} k`;
  }
  return (
    parseFloat(`${num}`) === parseFloat(num.toFixed(2)) ? num : num.toFixed(2)
  ).toString();
};

const getRandomNumber = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export { getCsvFormattedNumber, getAbbreviatedNumber, getRandomNumber };
